import { FC, useState } from 'react';

import { FormControl, MenuItem, Select } from '@mui/material';

import { Country } from 'src/hooks/useCountries';

type CountryDropDownProps = {
    countries: Country[];
    selectedCountryName: string;
    setSelectedCountryName: (name: string) => void;
    setAreaCode: (code: string) => void;
    disabled: boolean;
};

const CountryDropDown: FC<CountryDropDownProps> = ({
    countries,
    selectedCountryName,
    setSelectedCountryName,
    setAreaCode,
    disabled,
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const renderDropDownValue = (selected) => {
        const src = countries?.find((country) => {
            return country.name === selected;
        })?.flag;

        return (
            <span
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {src && (
                    <img
                        src={src}
                        alt="country flag"
                        style={{
                            borderRadius: '50%',
                            height: '24px',
                            width: '24px',
                            objectFit: 'cover',
                        }}
                    />
                )}
                {isOpen && selected}
            </span>
        );
    };

    const handleCountryChange = (event) => {
        const selectedCountryName = event.target.value;

        setSelectedCountryName(selectedCountryName);

        const foundCountry = countries?.find((country) => {
            return country.name === selectedCountryName || country.country === selectedCountryName;
        });

        if (foundCountry) {
            setAreaCode(foundCountry.country);
        }
    };

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        // eslint-disable-next-line id-length
        <FormControl sx={{ m: 1 }} variant="standard">
            <Select
                id="country select"
                value={selectedCountryName}
                onChange={handleCountryChange}
                onOpen={handleOpen}
                onClose={handleClose}
                open={isOpen}
                renderValue={(value) => {
                    return renderDropDownValue(value);
                }}
                sx={{
                    '&:before': {
                        borderBottom: 'none',
                    },
                    '&:after': {
                        borderBottom: 'none',
                    },
                    '&:hover:not(.Mui-disabled):before': {
                        borderBottom: 'none',
                    },
                    marginTop: '16.75px',
                    marginBottom: '16.75px',
                    marginLeft: '28px',
                }}
                disabled={disabled}
            >
                {countries.map((country) => {
                    return (
                        <MenuItem key={country.name} value={country.name}>
                            <img
                                src={country.flag}
                                alt="country flag"
                                style={{ maxWidth: '15px', marginRight: '5px' }}
                            />
                            {country.name}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default CountryDropDown;
